import { render, staticRenderFns } from "./blankPage.vue?vue&type=template&id=272c7c9e&"
import script from "./blankPage.vue?vue&type=script&lang=js&"
export * from "./blankPage.vue?vue&type=script&lang=js&"
import style0 from "./blankPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports